// extracted by mini-css-extract-plugin
export default {"editable-value":"app-people-PersonActivismOrganizer-PersonActivismOrganizer-module__Fvgr1zrFr1RcDnegV_Mu"};